import script from "./DVSStep5Confirmacion.vue?vue&type=script&setup=true&lang=js"
export * from "./DVSStep5Confirmacion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__